import { CustomFieldType } from "../alv-enums";

export class CustomFields
{
    waiverffId:number;
    fieldId:number;
    customFieldType: CustomFieldType;
    fieldName:string;
    length:number;
    isRequired:boolean;
    isActive:boolean;
    options:optionValue[];
    fieldValue:any=null;
    guestId:number;
}

export class optionValue
{
    id:number;
    text:string;
}